import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, TextField, Checkbox } from 'emerald-ui';
import { fetchCountries } from '../../api/countries';
import { fetchStates } from '../../api/states';

class SignUpFormAddress extends Component {
  constructor(props) {
    super(props);
    this.state = {
      countries: [],
      states: [],
    };
  }

  async componentWillMount() {
    const countriesResponse = await fetchCountries();
    this.setState({ countries: countriesResponse.data });

    const statesResponse = await fetchStates();
    this.setState({ states: statesResponse.data });
  }

  handleChange = (key) => (event) => {
    const value = event.target.value;
    this.props.handleFieldChange({ [key]: value });
  };

  handleAddressOutsideUSChange = (event) => {
    const checked = event.target.checked;
    const data = { isAddressOutsideUS: checked };
    if (checked) {
      data.state = '';
    }
    this.props.handleFieldChange(data);
  };

  render() {
    const {
      streetAddress = {},
      houseNumber = {},
      country = {},
      city = {},
      state = {},
      zipCode = {},
      isAddressOutsideUS,
    } = this.props;

    let { countries = [], states = [] } = this.state;

    if (isAddressOutsideUS) {
      countries = countries.filter((country) => country.code !== 'US');
    } else {
      countries = countries.filter((country) => country.code === 'US');
    }

    const stateOptions = states.map((state, index) => (
      <option key={index + 1} value={state.code}>
        {state.description}
      </option>
    ));
    stateOptions.unshift(
      <option key="0" value="">
        Select state
      </option>
    );

    const countryOptions = countries.map((country, index) => (
      <option key={index + 1} value={country.code}>
        {country.description}
      </option>
    ));
    countryOptions.unshift(
      <option key="0" value="">
        Select country
      </option>
    );

    return (
      <div>
        <Row className="sign-up-fields-section">
          <Col xs={12}>
            <Checkbox
              id="addressOutsideUS"
              label="Address is outside of US"
              defaultChecked={isAddressOutsideUS}
              onChange={this.handleAddressOutsideUSChange}
            />
          </Col>
        </Row>
        <Row className="sign-up-fields-section">
          <Col xs={12}>
            <TextField
              id="streetAddress"
              shape="classic"
              placeholder="123 Pl Lane"
              label="Street address"
              onChange={this.handleChange('streetAddress')}
              maxLength="50"
              value={streetAddress.value || ''}
              error={streetAddress.displayErrors ? streetAddress.errorMsg : ''}
            />
          </Col>
        </Row>
        <Row className="sign-up-fields-section">
          <Col xs={12}>
            <TextField
              id="houseNumber"
              shape="classic"
              placeholder="Unit 100"
              label="Apt, ste, bldg"
              maxLength="50"
              onChange={this.handleChange('houseNumber')}
              value={houseNumber.value || ''}
              error={houseNumber.displayErrors ? houseNumber.errorMsg : ''}
            />
          </Col>
        </Row>
        <Row className="sign-up-fields-section">
          <Col xs={12}>
            <TextField
              id="country"
              type="select"
              shape="classic"
              label="Country"
              onChange={this.handleChange('country')}
              value={country.value || ''}
              error={country.displayErrors ? country.errorMsg : ''}
            >
              {countryOptions}
            </TextField>
          </Col>
        </Row>
        <Row className="sign-up-fields-section">
          <Col xs={12} md={7}>
            <TextField
              id="city"
              shape="classic"
              placeholder="Broomfield"
              label="City"
              onChange={this.handleChange('city')}
              value={city.value || ''}
              error={city.displayErrors ? city.errorMsg : ''}
            />
          </Col>
          {!isAddressOutsideUS && (
            <Col xs={12} md={5} className="sign-up-form-margin-top-xs">
              <TextField
                id="state"
                type="select"
                shape="classic"
                label="State"
                disabled={isAddressOutsideUS}
                onChange={this.handleChange('state')}
                value={state.value || ''}
                error={state.displayErrors ? state.errorMsg : ''}
              >
                {stateOptions}
              </TextField>
            </Col>
          )}
        </Row>
        <Row className="sign-up-fields-section">
          <Col xs={12}>
            <TextField
              id="zipCode"
              shape="classic"
              placeholder="12345"
              label="Zip"
              maxLength="9"
              onChange={this.handleChange('zipCode')}
              value={zipCode.value || ''}
              error={zipCode.displayErrors ? zipCode.errorMsg : ''}
            />
          </Col>
        </Row>
      </div>
    );
  }
}

SignUpFormAddress.propTypes = {
  handleFieldChange: PropTypes.func,
  country: PropTypes.object,
};

SignUpFormAddress.defaultProps = {
  handleFieldChange: () => {},
  country: {},
};

export default SignUpFormAddress;



// WEBPACK FOOTER //
// ./src/components/SignUpFormAddress/SignUpFormAddress.js